import { z } from "zod";

export const schema = z.object({
  name: z.string().nonempty("Nome do produto é obrigatório"),
  styling: z
    .object({
      fontColor: z.string().default("#000000"),
      primaryColor: z.string().default("#E0E0E0"),
      secondaryColor: z.string().default("#BDBDBD"),
    })
    .default({
      fontColor: "#000000",
      primaryColor: "#E0E0E0",
      secondaryColor: "#BDBDBD",
    }),
});
